<template>
  <div>
    <el-input v-model="newMessage" />
    <el-button @click="sendMessage">发送</el-button>
    <div v-for="msg in messages" :key="msg.id">
      {{ msg.content }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      newMessage: '',
      messages: []
    };
  },
  created() {
    // 监听全局消息事件
    this.$root.$on('websocket-message', this.handleMessage);
  },
  methods: {
    // 发送消息到服务端
    sendMessage() {
      if (this.newMessage.trim()) {
        this.$parent.sendMessage('user456', this.newMessage);
        this.newMessage = '';
      }
    },

    // 处理接收消息
    handleMessage(message) {
      if (message.type === 'message') {
        this.messages.push({
          id: message.timestamp,
          content: message.content
        });
      }
    }
  },
  beforeDestroy() {
    this.$root.$off('websocket-message', this.handleMessage);
  }
};
</script>